'use client';

import React from 'react';
import { Box, Typography, Card, Divider } from '@mui/material';
import TitleBar from '../layout/TitleBar';
import { AvatarUpload } from '../shared/AvatarUpload';
import { useAuthData } from '@/hooks/getAuthData';
import { BusinessUnitThemeFontSelect } from '@/components/shared/BusinessUnitThemeFontSelect';
import { AppearanceAccentSettings } from '@/components/shared/AppearanceAccentSettings';

const SettingsPage: React.FC = () => {
  const { user: currentUser } = useAuthData();

  const initials = currentUser?.initials ||
    ((currentUser?.firstName?.[0] || '') + (currentUser?.lastName?.[0] || '')) ||
    'U';

  const breadcrumbs = [
    { label: 'Home', href: '/app/dashboard' },
    { label: 'Settings' },
  ];

  return (
    <>
      <TitleBar
        breadcrumbs={breadcrumbs}
        title="Settings"
      />

      <Box sx={{ padding: 3 }}>
        <Card sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Business unit
          </Typography>
          <Divider sx={{ my: 2 }} />
          <Typography variant="body1" color="text.secondary">
            {currentUser?.currentBusinessUnit?.name ||
              'No business unit context (refresh session or contact an administrator).'}
          </Typography>
          {currentUser?.businessUnits && currentUser.businessUnits.length > 1 ? (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Use the account menu (avatar) to switch between your assigned business units.
            </Typography>
          ) : null}
          <Box sx={{ mt: 3 }}>
            <BusinessUnitThemeFontSelect />
          </Box>
          <Divider sx={{ my: 3 }} />
          <AppearanceAccentSettings />
        </Card>

        <Card sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Profile Image
          </Typography>
          <Divider sx={{ my: 2 }} />
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <AvatarUpload
              size={150}
              showDelete={true}
              initials={initials}
            />
          </Box>
        </Card>
      </Box>
    </>
  );
};

export default SettingsPage;

